<style></style>
<template>
	<div class="properties-header">
		<div class="properties-visualizations">
			<div
				v-if="nonSpendableActorPhaseProperties"
				class="properties-header-nonSpendable clearfix"
			>
				<actor-property-bar-absolute
					v-for="ap in nonSpendableActorPhaseProperties"
					:srv-property-type-key="ap.property.type_key"
					:srv-phase-id="srvPhaseId"
					:actor-id="ap.actor_id"
					:actor-property-goal="goalFor(ap)"
					:icon-url="`/img/unionslabor/icons/${ap.property.type_key}.svg`"
					:key="ap.id"
					:value-units="ap.property.value_units"
				></actor-property-bar-absolute>
			</div>
			<div
				v-if="spendableActorProperty"
				class="properties-header-spendable"
				:key="spendableActorProperty.id"
			>
				<div>
					<img src="/img/unionslabor/icons/starcoin.svg" alt="stern">
				</div>
				<div class="available">
					<animated-number
						v-if="showSpendablePreview"
						:prev-number="spendableActorPropertyCurrentValue"
						:number="spendableValueWithPreview"
						:valueUnits="spendableActorProperty.property.value_units"
						:animation-duration="1"
					></animated-number>
					<span v-if="!showSpendablePreview">{{
						Math.floor(spendableActorPropertyCurrentValue)
					}}</span>
				</div>
				<div v-if="showSpendablePreview" class="spend-preview">
					<span
						:class='spendableActorProperty.preview_values.range[1] >= 0 ? "positive" : "negative"'
					>
						{{ spendableActorProperty.preview_values.range[1] > 0 ? "＋" : "" }}
						{{ spendableActorProperty.preview_values.range[1] }}
					</span>
				</div>
				<div v-if="!showSpendablePreview" class="spend-preview">{{ " " }}</div>
			</div>
		</div>
		<measure-action-button
			:current-actor-can-create-drafts="currentActorCanCreateDrafts"
			:previewing-measure="previewingMeasure"
		></measure-action-button>
	</div>
</template>

<script>
import MeasureActionButton from "../measures_components/measure_action_button.vue";
// Other components
import { i18n } from "../utils";
import ActorPropertyBarAbsolute from "./actor_property_bar_absolute.vue";
import AnimatedNumber from "./animated_number.vue";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: {
		srvPhaseId: Number,
		srvActorPropertiesGoal: Object,
		currentActorCanCreateDrafts: Boolean,
		srvForActorId: Number,
	},
	components: {
		"actor-property-bar-absolute": ActorPropertyBarAbsolute,
		"measure-action-button": MeasureActionButton,
		"animated-number": AnimatedNumber,
	},
	data: function () {
		return {
			actorPropertiesGoal: this.srvActorPropertiesGoal,
			forActorId:
				this.srvForActorId == undefined
					? pp.currentActorId
					: this.srvForActorId,
		};
	},
	watch: {
		previewingMeasure: function (newVal, oldVal) {
			//pp.log("previewing measure changed -- new, old:", newVal, oldVal);
			$(".ulab-button-enact")
				.addClass("ulab-button-animated-before")
				.removeClass("ulab-button-animated-active");
			if (newVal) {
				VueStore.commit("clearPreviewFor", this.forActorId);
				$(".PropertyValueBar__value, .PropertyValueBar__value-range").addClass(
					"no-transition",
				);
				window.setTimeout(() => {
					window.setTimeout(() => {
						$(".ulab-button-enact")
							.removeClass("ulab-button-animated-before")
							.addClass("ulab-button-animated-active");
					}, 100);
					$(
						".PropertyValueBar__value, .PropertyValueBar__value-range",
					).removeClass("no-transition");
					let modifiers;
					if (newVal.is_national_measure) {
						modifiers = newVal.modifiers;
					} else {
						modifiers = newVal.modifiers_by_actor.filter((mba) => {
							return (
								mba.modifiers_per_actor.find((mpa) => {
									return mpa.actor.id === this.forActorId;
								}) != undefined
							);
						});
						// pp.log("all mods, mods for actor:", newVal.modifiers, modifiers);
					}
					VueStore.commit("previewModifiersFor", {
						actorId: this.forActorId,
						modifiers: modifiers,
					});
				}, 1);
			} else {
				// pp.log("Clearing preview mods");
				VueStore.commit("clearPreviewFor", this.forActorId);
			}
		},
	},
	computed: {
		previewingMeasure: function () {
			return VueStore.getters.previewingMeasure();
		},
		spendableActorProperty: function () {
			return VueStore.getters.actorPropertyOfTypeFor(
				this.forActorId,
				"action_points",
			);
		},
		spendableActorPropertyCurrentValue: function () {
			const phaseId = this.srvPhaseId || pp.gameState.phaseId;
			return this.spendableActorProperty.values[phaseId].current_value;
		},
		nonSpendableActorPhaseProperties: function () {
			return VueStore.getters.actorsPropertiesWithoutTypeFor(
				this.forActorId,
				"action_points",
			);
		},
		spendableValueWithPreview: function () {
			const spendableProp = this.spendableActorProperty;
			if (spendableProp.preview_values) {
				return (
					this.spendableActorPropertyCurrentValue +
					spendableProp.preview_values.range[1]
				); // AP is always a single vaule
			}

			return this.spendableActorPropertyCurrentValue;
		},
		showSpendablePreview: function () {
			return (
				this.spendableActorProperty.old_current_value == undefined &&
				this.spendableActorProperty.preview_values != undefined
			);
		},
		locale: function () {
			return I18n.locale;
		},
	},
	mounted() {
		pp.vue.bus.$on(
			"actorPropertiesGoal-ACHIEVE",
			this.onActorPropertiesGoalAchieved,
		);
	},
	beforeDestroy() {
		pp.vue.bus.$off(
			"actorPropertiesGoal-ACHIEVE",
			this.onActorPropertiesGoalAchieved,
		);
	},
	methods: {
		onActorPropertiesGoalAchieved(res) {
			// @ts-expect-error
			if (res && res.id != this.actorPropertiesGoal.id) {
				pp.vue.bus.$emit("highlight-goal-numbers");
				this.$set(this, "actorPropertiesGoal", res);
				// VueStore.commit("clearPreviewFor", this.forActorId); this will be done implicitly in the actorsPropertiesStore.updateActorsPropertiesFor
				VueStore.commit("markTransitionOmissionOfProperties", {
					actorId: this.forActorId,
					setTimeout: true,
				});
			}
		},
		goalFor(actorProperty) {
			// @ts-expect-error
			if (!this.actorPropertiesGoal.unlockable_calculations.length) {
				return undefined;
			}
			// @ts-expect-error
			const calculation = this.actorPropertiesGoal.unlockable_calculations.find(
				(uc) => uc.comparable == actorProperty.property.type_key,
			);
			return calculation !== undefined
				? calculation.comparison_value
				: undefined;
		},
	},
};
</script>
